import {
  CANDIDATE_CANCEL_E_APP_REQUEST,
  CHECK_AD_SUBMIT_WARNING_REQUEST,
  CHECK_DUPLICATED_PHONE_REQUEST,
  CHECK_DUPLICATED_PHONE_SUCCESS,
  CHECK_STEP_CANDIDATE_REQUEST,
  CHECK_STEP_CANDIDATE_SUCCESS,
  CREATE_POST_PRESIGNED_REQUEST,
  CREATE_POST_PRESIGNED_SUCCESS,
  DOWNLOAD_BY_CANDIDATE_REQUEST,
  SET_ERECRUITMENT_PRE_CANDIDATE_ID,
  FLAIR_GET_PRE_CANDIDATE_DETAIL_DATA,
  FLAIR_RECRUITER_CANCEL_E_APP_REQUEST,
  FLAIR_REGISTER_BY_RECRUITER_REQUEST,
  FLAIR_SAVE_BY_RECRUITER_REQUEST,
  FLAIR_SET_AD_TEAM_DATA,
  FLAIR_SET_AM_TEAM_DATA,
  FLAIR_SET_BANK_OFFICE_DATA,
  FLAIR_SET_PRE_CANDIDATE_DETAIL_DATA,
  FLAIR_SET_TEAM_OFFICE_DATA,
  FLAIR_VALIDATE_CANDIDATE_REQUEST,
  FTA_CHECK_STEP_CANDIDATE_REQUEST,
  FTA_GENERATE_OTP_REQUEST,
  FTA_RELOAD_OTP_REQUEST,
  FTA_VERIFY_OTP_REQUEST,
  GENERATE_OTP_REQUEST,
  GENERATE_OTP_SUCCESS,
  GET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  GET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  GET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA,
  GET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA,
  GET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA,
  GET_ALL_AD_DATA,
  GET_ALL_AM_DATA,
  GET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  GET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  GET_ASCORE_REQUEST,
  GET_ASCORE_SUCCESS,
  GET_CHECK_APPLICATION_STATUS_REQUEST,
  GET_CHECK_APPLICATION_STATUS_SUCCESS,
  GET_DISTRICTS_DATA,
  GET_DOC_BUFFERED_DATA,
  GET_EAPP_PROCESS_HISTORY_DATA,
  GET_ERE_DETAIL_REQUEST,
  GET_ERE_DETAIL_SUCCESS,
  GET_FILES_DATA,
  GET_KAPTCHA_DATA,
  GET_LIST_OF_VALUE_DATA,
  GET_LIST_OFFICE_DATA,
  GET_LIST_TRAINING_CLASS_DATA,
  GET_PRE_CANDIDATE_DETAIL_DATA,
  GET_PROVINCES_DATA,
  GET_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  GET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  GET_STATUS_DATA,
  GET_TITLE_FOR_NOUS_DATA,
  GET_TRACKING_REQUEST,
  GET_TRACKING_SUCCESS,
  GET_WARDS_DATA,
  GET_WARDS_2_LEVEL_DATA,
  NOUS_CANDIDATE_CANCEL_E_APP_REQUEST,
  NOUS_GET_ASCORE_REQUEST,
  NOUS_GET_ASCORE_SUCCESS,
  NOUS_GET_PRE_CANDIDATE_DETAIL_DATA,
  NOUS_RECRUITER_CANCEL_E_APP_REQUEST,
  NOUS_REGISTER_BY_RECRUITER_REQUEST,
  NOUS_SAVE_BY_RECRUITER_REQUEST,
  NOUS_SET_PRE_CANDIDATE_DETAIL_DATA,
  NOUS_UPDATE_BY_AD_REQUEST,
  NOUS_UPDATE_BY_AM_REQUEST,
  NOUS_UPDATE_BY_AOS_REQUEST,
  NOUS_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  POST_FILE_REQUEST,
  POST_FILE_SUCCESS,
  RECRUITER_CANCEL_E_APP_REQUEST,
  REGISTER_BY_RECRUITER_REQUEST,
  REGISTER_BY_RECRUITER_SUCCESS,
  RELOAD_OTP_REQUEST,
  RELOAD_OTP_SUCCESS,
  SAVE_BY_RECRUITER_REQUEST,
  SET_AD_CONFIG_FILTER,
  SET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  SET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  SET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA,
  SET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA,
  SET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA,
  SET_ALL_AD_DATA,
  SET_ALL_AM_DATA,
  SET_AOS_CONFIG_FILTER,
  SET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  SET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  SUBMIT_CHANGE_COURSE_REQUEST,
  VALIDATE_CANDIDATE_INFO_CHANGE_COURSE_REQUEST,
  SET_CONFIG_FILTER,
  SET_DISTRICTS_DATA,
  SET_EAPP_PROCESS_HISTORY_DATA,
  SET_FILES_DATA,
  SET_KAPTCHA_DATA,
  SET_LIST_OF_VALUE_DATA,
  SET_LIST_OFFICE_DATA,
  SET_LIST_TRAINING_CLASS_DATA,
  SET_PRE_CANDIDATE_DETAIL_DATA,
  SET_PROVINCES_DATA,
  SET_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  SET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  SET_STATUS_DATA,
  SET_TITLE_FOR_NOUS_DATA,
  SET_WARDS_DATA,
  UPDATE_BY_AD_REQUEST,
  UPDATE_BY_AM_REQUEST,
  UPDATE_BY_AOS_REQUEST,
  UPDATE_BY_PRE_CANDIDATE_REQUEST,
  UPDATE_BY_PRE_CANDIDATE_SUCCESS,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  FLAIR_SAVE_BY_CANDIDATE_REQUEST,
  FLAIR_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  FLAIR_CANCEL_BY_PRE_CANDIDATE_REQUEST,
  FLAIR_RE_SUBMIT_BY_RECRUITER_REQUEST,
  FLAIR_UPDATE_BY_AD_REQUEST,
  FLAIR_PICK_UP_BY_AOS,
  FLAIR_UPDATE_BY_AOS_REQUEST,
  FLAIR_SAVE_BY_AOS_REQUEST,
  DELASOL_REGISTER_BY_RECRUITER_REQUEST,
  DELASOL_SAVE_BY_RECRUITER_REQUEST,
  DELASOL_RECRUITER_CANCEL_E_APP_REQUEST,
  DELASOL_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  DELASOL_CLONE_E_APP_REQUEST,
  CLONE_BY_RECRUITER_REQUEST,
  CLONE_BY_RECRUITER_REQUEST_FTA,
  NOUS_SAVE_BY_CANDIDATE_REQUEST,
  AGENCY_SAVE_BY_CANDIDATE_REQUEST,
  SET_ERECRUITMENT_PRE_CANDIDATE_CHANNEL_CODE,
  CHECK_ID_NUMBER_IN_AGIS_REQUEST,
  NOUS_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  DELASOL_SAVE_BY_CANDIDATE_REQUEST,
  DELASOL_VALIDATE_CANDIDATE_REQUEST,
  DELASOL_CANCEL_BY_CANDIDATE_REQUEST,
  DELASOL_RE_SUBMIT_BY_RECRUITER_REQUEST,
  DELASOL_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  DELASOL_UPDATE_BY_APP1_REQUEST,
  DELASOL_UPDATE_BY_APP2_REQUEST,
  DELASOL_SAVE_BY_AOS_REQUEST,
  DELASOL_UPDATE_BY_AOS_REQUEST,
  GET_EAPP_PROCESS_HISTORY_DATA_V2,
  SET_EAPP_PROCESS_HISTORY_DATA_V2,
} from './constants';

const getSearchPreCandidatePendingDataAction = (payload) => ({
  type: GET_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  payload,
});

const setSearchPreCandidatePendingDataAction = (payload) => ({
  type: SET_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  payload,
});

const getSearchPreCandidateProcessedDataAction = (payload) => ({
  type: GET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  payload,
});

const setSearchPreCandidateProcessedDataAction = (payload) => ({
  type: SET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  payload,
});

const getADSearchPreCandidatePendingDataAction = (payload) => ({
  type: GET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  payload,
});

const setADSearchPreCandidatePendingDataAction = (payload) => ({
  type: SET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  payload,
});

const getADSearchPreCandidateProcessedDataAction = (payload) => ({
  type: GET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  payload,
});

const getADSearchPreCandidateCourseDataAction = (payload) => ({
  type: GET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA,
  payload,
});

const getADSearchInfoCandidateCourseDataAction = (payload) => ({
  type: GET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA,
  payload,
});

const getADSearchClassCandidateCourseDataAction = (payload) => ({
  type: GET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA,
  payload,
});

const setADSearchPreCandidateProcessedDataAction = (payload) => ({
  type: SET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  payload,
});

const setADSearchPreCandidateCourseDataAction = (payload) => ({
  type: SET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA,
  payload,
});

const setADSearchInfoCandidateCourseDataAction = (payload) => ({
  type: SET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA,
  payload,
});

const setADSearchClassCandidateCourseDataAction = (payload) => ({
  type: SET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA,
  payload,
});

const getAOSSearchPreCandidatePendingDataAction = (payload) => ({
  type: GET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  payload,
});

const setAOSSearchPreCandidatePendingDataAction = (payload) => ({
  type: SET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA,
  payload,
});

const getAOSSearchPreCandidateProcessedDataAction = (payload) => ({
  type: GET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  payload,
});

const setAOSSearchPreCandidateProcessedDataAction = (payload) => ({
  type: SET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA,
  payload,
});

const submitChangeCourse = (payload, callback) => ({
  type: SUBMIT_CHANGE_COURSE_REQUEST,
  payload,
  callback,
});

const validateCandidateInfoChangeCourse = (payload, callback) => ({
  type: VALIDATE_CANDIDATE_INFO_CHANGE_COURSE_REQUEST,
  payload,
  callback,
});

const getStatusDataAction = (payload) => ({
  type: GET_STATUS_DATA,
  payload,
});

const setStatusDataAction = (payload) => ({
  type: SET_STATUS_DATA,
  payload,
});

const getAllAdDataAction = (payload) => ({
  type: GET_ALL_AD_DATA,
  payload,
});

const setAllAdDataAction = (payload) => ({
  type: SET_ALL_AD_DATA,
  payload,
});

const getAllAmDataAction = (payload) => ({
  type: GET_ALL_AM_DATA,
  payload,
});

const setAllAmDataAction = (payload) => ({
  type: SET_ALL_AM_DATA,
  payload,
});

const getListTrainingClassDataAction = (payload) => ({
  type: GET_LIST_TRAINING_CLASS_DATA,
  payload,
});

const setListTrainingClassDataAction = (payload) => ({
  type: SET_LIST_TRAINING_CLASS_DATA,
  payload,
});

const getProvincesDataAction = (payload) => ({
  type: GET_PROVINCES_DATA,
  payload,
});

const setProvincesDataAction = (payload) => ({
  type: SET_PROVINCES_DATA,
  payload,
});

const setFilterConfig = (payload) => ({
  type: SET_CONFIG_FILTER,
  payload,
});

const setADFilterConfig = (payload) => ({
  type: SET_AD_CONFIG_FILTER,
  payload,
});

const setAOSFilterConfig = (payload) => ({
  type: SET_AOS_CONFIG_FILTER,
  payload,
});

const getListOfValueDataAction = (payload) => ({
  type: GET_LIST_OF_VALUE_DATA,
  payload,
});

const setListOfValueDataAction = (payload) => ({
  type: SET_LIST_OF_VALUE_DATA,
  payload,
});

const getDistrictsDataAction = (payload, callback) => ({
  type: GET_DISTRICTS_DATA,
  payload,
  callback,
});

const setDistrictsDataAction = (payload) => ({
  type: SET_DISTRICTS_DATA,
  payload,
});

const getWardsDataAction = (payload, callback) => ({
  type: GET_WARDS_DATA,
  payload,
  callback,
});

const getWards2LevelDataAction = (payload, callback) => ({
  type: GET_WARDS_2_LEVEL_DATA,
  payload,
  callback,
});

const setWardsDataAction = (payload) => ({
  type: SET_WARDS_DATA,
  payload,
});

const getListOfficeDataAction = (payload) => ({
  type: GET_LIST_OFFICE_DATA,
  payload,
});

const setListOfficeDataAction = (payload) => ({
  type: SET_LIST_OFFICE_DATA,
  payload,
});

const registerByRecruiterRequest = (payload, callback) => ({
  type: REGISTER_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const updateEmailByRecruiterRequest = (payload, callback) => ({
  type: UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const registerByRecruiterSuccess = (payload) => ({
  type: REGISTER_BY_RECRUITER_SUCCESS,
  payload,
});

const checkDuplicatedPhoneRequest = (payload, callback) => ({
  type: CHECK_DUPLICATED_PHONE_REQUEST,
  payload,
  callback,
});
const checkDuplicatedPhoneSuccess = (payload) => ({
  type: CHECK_DUPLICATED_PHONE_SUCCESS,
  payload,
});

const createPostPresignedRequest = (payload, callback) => ({
  type: CREATE_POST_PRESIGNED_REQUEST,
  payload,
  // callback,
});
const createPostPresignedSuccess = () => ({
  type: CREATE_POST_PRESIGNED_SUCCESS,
});

const postFileRequest = (payload, callback) => ({
  type: POST_FILE_REQUEST,
  payload,
  callback,
});
const postFileSuccess = (payload) => ({
  type: POST_FILE_SUCCESS,
  payload,
});

const getTrackingRequest = (payload) => ({
  type: GET_TRACKING_REQUEST,
  payload,
});
const getTrackingSuccess = (payload) => ({
  type: GET_TRACKING_SUCCESS,
  payload,
});

const getFilesDataAction = (payload) => ({
  type: GET_FILES_DATA,
  payload,
});
const setFilesDataAction = (payload) => ({
  type: SET_FILES_DATA,
  payload,
});

const checkStepCandidateRequest = (payload, callback) => ({
  type: CHECK_STEP_CANDIDATE_REQUEST,
  payload,
  callback,
});
const checkStepCandidateSuccess = (payload) => ({
  type: CHECK_STEP_CANDIDATE_SUCCESS,
  payload,
});

const getKaptchaDataAction = (payload) => ({
  type: GET_KAPTCHA_DATA,
  payload,
});
const setKaptchaDataAction = (payload) => ({
  type: SET_KAPTCHA_DATA,
  payload,
});

const generateOTPRequest = (payload, callback) => ({
  type: GENERATE_OTP_REQUEST,
  payload,
  callback,
});
const generateOTPSuccess = (payload) => ({
  type: GENERATE_OTP_SUCCESS,
  payload,
});

const reloadOTPRequest = (payload, callback) => ({
  type: RELOAD_OTP_REQUEST,
  payload,
  callback,
});
const reloadOTPSuccess = (payload) => ({
  type: RELOAD_OTP_SUCCESS,
  payload,
});

const verifyOTPRequest = (payload, callback) => ({
  type: VERIFY_OTP_REQUEST,
  payload,
  callback,
});
const verifyOTPSuccess = (payload) => ({
  type: VERIFY_OTP_SUCCESS,
  payload,
});

const getCheckApplicationStatusRequest = (payload, callback) => ({
  type: GET_CHECK_APPLICATION_STATUS_REQUEST,
  payload,
  callback,
});
const getCheckApplicationStatusSuccess = (payload) => ({
  type: GET_CHECK_APPLICATION_STATUS_SUCCESS,
  payload,
});

// DETAIL
const getPreCandidateDataAction = (payload) => ({
  type: GET_PRE_CANDIDATE_DETAIL_DATA,
  payload,
});

const setPreCandidateDataAction = (payload) => ({
  type: SET_PRE_CANDIDATE_DETAIL_DATA,
  payload,
});

const getEappProcessHistoryDataAction = (payload) => ({
  type: GET_EAPP_PROCESS_HISTORY_DATA,
  payload,
});

const setEappProcessHistoryDataAction = (payload) => ({
  type: SET_EAPP_PROCESS_HISTORY_DATA,
  payload,
});

const getDocBufferedDataAction = (payload, callback) => ({
  type: GET_DOC_BUFFERED_DATA,
  payload,
  callback,
});

const getEreDetailRequest = (payload, callback) => ({
  type: GET_ERE_DETAIL_REQUEST,
  payload,
  callback,
});

const getEreDetailSuccess = (payload) => ({
  type: GET_ERE_DETAIL_SUCCESS,
  payload,
});

const updateByPreCandidateRequest = (payload, callback) => ({
  type: UPDATE_BY_PRE_CANDIDATE_REQUEST,
  payload,
  callback,
});
const updateByPreCandidateSuccess = (payload) => ({
  type: UPDATE_BY_PRE_CANDIDATE_SUCCESS,
  payload,
});

const candidateCancelEAppRequest = (payload, callback) => ({
  type: CANDIDATE_CANCEL_E_APP_REQUEST,
  payload,
  callback,
});

const updateByAmRequest = (payload, callback) => ({
  type: UPDATE_BY_AM_REQUEST,
  payload,
  callback,
});

const saveByRecruiterRequest = (payload, callback) => ({
  type: SAVE_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const recruiterCancelEAppRequest = (payload, callback) => ({
  type: RECRUITER_CANCEL_E_APP_REQUEST,
  payload,
  callback,
});

const downloadByCandidateRequest = (payload, callback) => ({
  type: DOWNLOAD_BY_CANDIDATE_REQUEST,
  payload,
  callback,
});

const getAscoreRequest = (payload, callback) => ({
  type: GET_ASCORE_REQUEST,
  payload,
  callback,
});

const getAscoreSuccess = (payload) => ({
  type: GET_ASCORE_SUCCESS,
  payload,
});

const updateByAdRequest = (payload, callback) => ({
  type: UPDATE_BY_AD_REQUEST,
  payload,
  callback,
});

const updateByAosRequest = (payload, callback) => ({
  type: UPDATE_BY_AOS_REQUEST,
  payload,
  callback,
});

// Nous

const getTitleForNousDataAction = (payload) => ({
  type: GET_TITLE_FOR_NOUS_DATA,
  payload,
});

const setTitleForNousDataAction = (payload) => ({
  type: SET_TITLE_FOR_NOUS_DATA,
  payload,
});

const nousRegisterByRecruiterRequest = (payload, callback) => ({
  type: NOUS_REGISTER_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const nousUpdateEmailByRecruiterRequest = (payload, callback) => ({
  type: NOUS_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const nousSaveByRecruiterRequest = (payload, callback) => ({
  type: NOUS_SAVE_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const nousRecruiterCancelEAppRequest = (payload, callback) => ({
  type: NOUS_RECRUITER_CANCEL_E_APP_REQUEST,
  payload,
  callback,
});

const nousUpdateByPreCandidateRequest = (payload, callback) => ({
  type: NOUS_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  payload,
  callback,
});

const nousCandidateCancelEAppRequest = (payload, callback) => ({
  type: NOUS_CANDIDATE_CANCEL_E_APP_REQUEST,
  payload,
  callback,
});

const nousGetPreCandidateDataAction = (payload) => ({
  type: NOUS_GET_PRE_CANDIDATE_DETAIL_DATA,
  payload,
});

const nousSetPreCandidateDataAction = (payload) => ({
  type: NOUS_SET_PRE_CANDIDATE_DETAIL_DATA,
  payload,
});

const ftaCheckStepCandidateRequest = (payload, callback) => ({
  type: FTA_CHECK_STEP_CANDIDATE_REQUEST,
  payload,
  callback,
});

const ftaGenerateOTPRequest = (payload, callback) => ({
  type: FTA_GENERATE_OTP_REQUEST,
  payload,
  callback,
});

const ftaReloadOTPRequest = (payload, callback) => ({
  type: FTA_RELOAD_OTP_REQUEST,
  payload,
  callback,
});

const ftaVerifyOTPRequest = (payload, callback) => ({
  type: FTA_VERIFY_OTP_REQUEST,
  payload,
  callback,
});

const nousUpdateByAmRequest = (payload, callback) => ({
  type: NOUS_UPDATE_BY_AM_REQUEST,
  payload,
  callback,
});

const nousGetAscoreRequest = (payload, callback) => ({
  type: NOUS_GET_ASCORE_REQUEST,
  payload,
  callback,
});

const nousGetAscoreSuccess = (payload) => ({
  type: NOUS_GET_ASCORE_SUCCESS,
  payload,
});

const nousUpdateByAdRequest = (payload, callback) => ({
  type: NOUS_UPDATE_BY_AD_REQUEST,
  payload,
  callback,
});

const nousUpdateByAosRequest = (payload, callback) => ({
  type: NOUS_UPDATE_BY_AOS_REQUEST,
  payload,
  callback,
});

// Flair

const flairValidateCandidate = (payload, callback) => ({
  type: FLAIR_VALIDATE_CANDIDATE_REQUEST,
  payload,
  callback,
});

const flairSaveByRecruiterRequest = (payload, callback) => ({
  type: FLAIR_SAVE_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const flairGetPreCandidateDataAction = (payload) => ({
  type: FLAIR_GET_PRE_CANDIDATE_DETAIL_DATA,
  payload,
});

const flairSetPreCandidateDataAction = (payload) => ({
  type: FLAIR_SET_PRE_CANDIDATE_DETAIL_DATA,
  payload,
});

const flairRecruiterCancelEAppRequest = (payload, callback) => ({
  type: FLAIR_RECRUITER_CANCEL_E_APP_REQUEST,
  payload,
  callback,
});

const flairSetBankOfficesDataAction = (payload) => ({
  type: FLAIR_SET_BANK_OFFICE_DATA,
  payload,
});

const flairSetTeamOfficesDataAction = (payload) => ({
  type: FLAIR_SET_TEAM_OFFICE_DATA,
  payload,
});

const flairSetAmTeamsDataAction = (payload) => ({
  type: FLAIR_SET_AM_TEAM_DATA,
  payload,
});

const flairSetAdTeamsDataAction = (payload) => ({
  type: FLAIR_SET_AD_TEAM_DATA,
  payload,
});

const flairRegisterByRecruiterRequest = (payload, callback) => ({
  type: FLAIR_REGISTER_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const setERecruitmentPreCandidateId = (payload) => ({
  type: SET_ERECRUITMENT_PRE_CANDIDATE_ID,
  payload,
});

const flairSaveByCandidateAction = (payload, callback) => ({
  type: FLAIR_SAVE_BY_CANDIDATE_REQUEST,
  payload,
  callback,
});

const flairUpdateByPreCandidateRequest = (payload, callback) => ({
  type: FLAIR_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  payload,
  callback,
});

const flairCandidateCancelEAppRequest = (payload, callback) => ({
  type: FLAIR_CANCEL_BY_PRE_CANDIDATE_REQUEST,
  payload,
  callback,
});

const flairResubmitByRecruiterRequest = (payload, callback) => ({
  type: FLAIR_RE_SUBMIT_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const flairUpdateByAdRequest = (payload, callback) => ({
  type: FLAIR_UPDATE_BY_AD_REQUEST,
  payload,
  callback,
});

const flairPickUpByAos = (payload, callback) => ({
  type: FLAIR_PICK_UP_BY_AOS,
  payload,
  callback,
});

const flairUpdateByAosRequest = (payload, callback) => ({
  type: FLAIR_UPDATE_BY_AOS_REQUEST,
  payload,
  callback,
});

const flairSaveByAosRequest = (payload, callback) => ({
  type: FLAIR_SAVE_BY_AOS_REQUEST,
  payload,
  callback,
});

const delasolSaveByRecruiterRequest = (payload, callback) => ({
  type: DELASOL_SAVE_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const delasolRegisterByRecruiterRequest = (payload, callback) => ({
  type: DELASOL_REGISTER_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const delasolRecruiterCancelEAppRequest = (payload, callback) => ({
  type: DELASOL_RECRUITER_CANCEL_E_APP_REQUEST,
  payload,
  callback,
});

const cloneAppNo = (payload) => ({
  type: CLONE_BY_RECRUITER_REQUEST,
  payload,
});

const cloneAppNoFTA = (payload) => ({
  type: CLONE_BY_RECRUITER_REQUEST_FTA,
  payload,
});

const agencySaveByCandidateAction = (payload, callback) => ({
  type: AGENCY_SAVE_BY_CANDIDATE_REQUEST,
  payload,
  callback,
});

const delasolValidateCandidate = (payload, callback) => ({
  type: DELASOL_VALIDATE_CANDIDATE_REQUEST,
  payload,
  callback,
});

const delasolUpdateEmailByRecruiterRequest = (payload, callback) => ({
  type: DELASOL_UPDATE_EMAIL_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const delasolCloneEappAction = (payload, callback) => ({
  type: DELASOL_CLONE_E_APP_REQUEST,
  payload,
  callback,
});

const nousSaveByCandidateAction = (payload, callback) => ({
  type: NOUS_SAVE_BY_CANDIDATE_REQUEST,
  payload,
  callback,
});

const setERecruitmentPreCandidateChannelCode = (payload) => ({
  type: SET_ERECRUITMENT_PRE_CANDIDATE_CHANNEL_CODE,
  payload,
});

const checkIdNumberInAgisAction = (payload, callback) => ({
  type: CHECK_ID_NUMBER_IN_AGIS_REQUEST,
  payload,
  callback,
});

const checkAdSubmitWarningRequest = (payload, callback) => ({
  type: CHECK_AD_SUBMIT_WARNING_REQUEST,
  payload,
  callback,
});

const delasolSaveByCandidateAction = (payload, callback) => ({
  type: DELASOL_SAVE_BY_CANDIDATE_REQUEST,
  payload,
  callback,
});

const delasolCandidateCancelEAppRequest = (payload, callback) => ({
  type: DELASOL_CANCEL_BY_CANDIDATE_REQUEST,
  payload,
  callback,
});

const delasolResubmitByRecruiterRequest = (payload, callback) => ({
  type: DELASOL_RE_SUBMIT_BY_RECRUITER_REQUEST,
  payload,
  callback,
});

const delasolUpdateByPreCandidateRequest = (payload, callback) => ({
  type: DELASOL_UPDATE_BY_PRE_CANDIDATE_REQUEST,
  payload,
  callback,
});

const delasolUpdateByApproval1Request = (payload, callback) => ({
  type: DELASOL_UPDATE_BY_APP1_REQUEST,
  payload,
  callback,
});

const delasolUpdateByApproval2Request = (payload, callback) => ({
  type: DELASOL_UPDATE_BY_APP2_REQUEST,
  payload,
  callback,
});

const delasolSaveByAosRequest = (payload, callback) => ({
  type: DELASOL_SAVE_BY_AOS_REQUEST,
  payload,
  callback,
});

const delasolUpdateByAosRequest = (payload, callback) => ({
  type: DELASOL_UPDATE_BY_AOS_REQUEST,
  payload,
  callback,
});

const getEAppProcessHistoryDataActionV2 = (payload) => ({
  type: GET_EAPP_PROCESS_HISTORY_DATA_V2,
  payload,
});

const setEAppProcessHistoryDataActionV2 = (payload) => ({
  type: SET_EAPP_PROCESS_HISTORY_DATA_V2,
  payload,
});

export {
  setFilterConfig,
  getSearchPreCandidatePendingDataAction,
  getSearchPreCandidateProcessedDataAction,
  setSearchPreCandidatePendingDataAction,
  setSearchPreCandidateProcessedDataAction,
  getStatusDataAction,
  setStatusDataAction,
  getListOfValueDataAction,
  setListOfValueDataAction,
  getProvincesDataAction,
  setProvincesDataAction,
  getDistrictsDataAction,
  setDistrictsDataAction,
  getWardsDataAction,
  getWards2LevelDataAction,
  setWardsDataAction,
  getListOfficeDataAction,
  setListOfficeDataAction,
  registerByRecruiterRequest,
  updateEmailByRecruiterRequest,
  registerByRecruiterSuccess,
  checkDuplicatedPhoneRequest,
  checkDuplicatedPhoneSuccess,
  setADFilterConfig,
  getADSearchPreCandidatePendingDataAction,
  setADSearchPreCandidatePendingDataAction,
  getADSearchPreCandidateProcessedDataAction,
  setADSearchPreCandidateProcessedDataAction,
  getADSearchPreCandidateCourseDataAction,
  getADSearchInfoCandidateCourseDataAction,
  getADSearchClassCandidateCourseDataAction,
  setADSearchPreCandidateCourseDataAction,
  setADSearchInfoCandidateCourseDataAction,
  setADSearchClassCandidateCourseDataAction,
  getAllAdDataAction,
  setAllAdDataAction,
  getListTrainingClassDataAction,
  setListTrainingClassDataAction,
  createPostPresignedRequest,
  createPostPresignedSuccess,
  postFileRequest,
  postFileSuccess,
  getTrackingRequest,
  getTrackingSuccess,
  getFilesDataAction,
  setFilesDataAction,
  updateByPreCandidateRequest,
  updateByPreCandidateSuccess,
  checkStepCandidateRequest,
  checkStepCandidateSuccess,
  getKaptchaDataAction,
  setKaptchaDataAction,
  generateOTPRequest,
  generateOTPSuccess,
  verifyOTPRequest,
  verifyOTPSuccess,
  reloadOTPRequest,
  reloadOTPSuccess,
  getCheckApplicationStatusRequest,
  getCheckApplicationStatusSuccess,
  getEreDetailRequest,
  getEreDetailSuccess,
  candidateCancelEAppRequest,
  // detail actions
  getPreCandidateDataAction,
  setPreCandidateDataAction,
  getEappProcessHistoryDataAction,
  setEappProcessHistoryDataAction,
  getDocBufferedDataAction,
  updateByAmRequest,
  saveByRecruiterRequest,
  recruiterCancelEAppRequest,
  downloadByCandidateRequest,
  getAscoreRequest,
  getAscoreSuccess,
  updateByAdRequest,
  getAOSSearchPreCandidatePendingDataAction,
  setAOSSearchPreCandidatePendingDataAction,
  getAOSSearchPreCandidateProcessedDataAction,
  setAOSSearchPreCandidateProcessedDataAction,
  submitChangeCourse,
  validateCandidateInfoChangeCourse,
  getAllAmDataAction,
  setAllAmDataAction,
  setAOSFilterConfig,
  updateByAosRequest,
  getTitleForNousDataAction,
  setTitleForNousDataAction,
  // Nous
  nousRegisterByRecruiterRequest,
  nousUpdateEmailByRecruiterRequest,
  nousSaveByRecruiterRequest,
  nousRecruiterCancelEAppRequest,
  nousUpdateByPreCandidateRequest,
  nousCandidateCancelEAppRequest,
  nousGetPreCandidateDataAction,
  nousSetPreCandidateDataAction,
  ftaCheckStepCandidateRequest,
  ftaGenerateOTPRequest,
  ftaReloadOTPRequest,
  ftaVerifyOTPRequest,
  nousUpdateByAmRequest,
  nousGetAscoreRequest,
  nousGetAscoreSuccess,
  nousUpdateByAdRequest,
  nousUpdateByAosRequest,
  // Flair
  flairValidateCandidate,
  flairSaveByRecruiterRequest,
  flairGetPreCandidateDataAction,
  flairSetPreCandidateDataAction,
  flairRecruiterCancelEAppRequest,
  flairSetBankOfficesDataAction,
  flairSetTeamOfficesDataAction,
  flairSetAmTeamsDataAction,
  flairSetAdTeamsDataAction,
  flairRegisterByRecruiterRequest,
  setERecruitmentPreCandidateId,
  flairSaveByCandidateAction,
  flairUpdateByPreCandidateRequest,
  flairCandidateCancelEAppRequest,
  flairResubmitByRecruiterRequest,
  flairUpdateByAdRequest,
  flairPickUpByAos,
  flairUpdateByAosRequest,
  flairSaveByAosRequest,
  // Delasol
  delasolSaveByRecruiterRequest,
  delasolRegisterByRecruiterRequest,
  delasolRecruiterCancelEAppRequest,
  delasolUpdateEmailByRecruiterRequest,
  delasolCloneEappAction,
  cloneAppNo,
  cloneAppNoFTA,
  // Save by Candidate Agency and Nous
  agencySaveByCandidateAction,
  nousSaveByCandidateAction,
  setERecruitmentPreCandidateChannelCode,
  checkIdNumberInAgisAction,
  checkAdSubmitWarningRequest,
  delasolSaveByCandidateAction,
  delasolValidateCandidate,
  delasolCandidateCancelEAppRequest,
  delasolResubmitByRecruiterRequest,
  delasolUpdateByPreCandidateRequest,
  delasolUpdateByApproval1Request,
  delasolUpdateByApproval2Request,
  delasolSaveByAosRequest,
  delasolUpdateByAosRequest,
  getEAppProcessHistoryDataActionV2,
  setEAppProcessHistoryDataActionV2,
};
